export const MenuItems = [
    {
        title: 'Home',
        url: '/',
        cName: 'nav-links'
    },
    {
        title: 'About me',
        url: '/#prueba',
        cName: 'nav-links'
    },
    {
        title: 'Work',
        url: '/work',
        cName: 'nav-links'
    },
    {
        title: 'Contact',
        url: '/contact',
        cName: 'nav-links'
    }
]